import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	AutocompleteInput,
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	ReferenceInput,
	TextInput
} from 'react-admin';
import { RecipeList } from './RecipeList';
import { RecipeDatagrid } from './RecipeDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { Recipe } from './Recipe';

export * from './Recipe';
export * from './RecipeCreate';
export * from './RecipeDatagrid';
export * from './RecipeEdit';
export * from './RecipeList';
export * from './RecipeShow';

const RecipesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'imageUrl', header: 'Image' },
	{ key: 'title', header: 'Title' },
	{ key: 'price', header: 'Price' },
	{ key: 'description', header: 'Description' },
	{ key: 'category.name', header: 'Category' },
	{ key: 'organization.name', header: 'Organization' }
];

export const RecipesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: Recipe) => entity;

	const recipesFilter = [
		<TextInput source="title" alwaysOn label="SEARCH"/>,
		<ReferenceInput
			step={1}
			label="CATEGORY"
			source="categoryId" reference="recipe-categories"
			alwaysOn
		>
			<AutocompleteInput optionText="name"/>
		</ReferenceInput>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('מתכונים', exportFields, exportDataMapper)}
				{...props}
				filters={recipesFilter}
				bulkActionButtons={<RecipesBulkActionButtons/>}
				title="RECIPES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <RecipeList/> : <RecipeDatagrid/>}
			</List>
		</Fragment>
	);
};
